import { BalanceApi } from '@api';
import { balanceTypes as actionTypes } from './types';

export const fetchBalances = (params) => (dispatch) => {
  dispatch({
    type: actionTypes.LOADING,
  });

  BalanceApi.getList(params)
    .then((response) => {
      dispatch({
        type: actionTypes.SUCCESS,
        payload: response,
      });
    })
    .catch((error) => {
      dispatch({
        type: actionTypes.FAILURE,
        message: `notify:general.errors.${error.status}`,
      });
    });
};
